import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import client, { apiErr } from "../lib/api";
import { Button, Input, Card } from "../components/ui";
import { KeyRound } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setErr("");
    if (!token) return setErr("Missing reset token. Please use the link from your recovery email.");
    if (pw.length < 6) return setErr("Password must be at least 6 characters.");
    if (pw !== pw2) return setErr("Passwords do not match.");
    setBusy(true);
    try {
      await client.post("/auth/recover/reset", { token, new_password: pw });
      setDone(true);
    } catch (e) { setErr(apiErr(e)); }
    setBusy(false);
  };

  return (
    <div className="grid min-h-screen place-items-center p-6" style={{ background: "var(--app-bg)" }}>
      <Card className="w-full max-w-md space-y-4" data-testid="reset-password">
        <div className="flex items-center gap-2 font-head text-xl"><KeyRound size={22} className="text-[var(--primary)]" /> Reset your password</div>
        {done ? (
          <>
            <p className="text-sm text-[#24A148]">Your password has been reset.</p>
            <Button onClick={() => nav("/login")} className="w-full" data-testid="reset-go-login">Go to sign in</Button>
          </>
        ) : (
          <>
            <Input label="New password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-new" />
            <Input label="Confirm new password" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-confirm" />
            {err && <div className="text-sm text-[#DA1E28]" data-testid="reset-error">{err}</div>}
            <Button onClick={submit} disabled={busy} className="w-full" data-testid="reset-submit">Set new password</Button>
          </>
        )}
      </Card>
    </div>
  );
}
